<template lang="html">
<div >
          <v-row >
            <v-col class="col-${val}" style="display:flex;">
              <input v-if="inputType === 'password'"
                class="otp-input"
                autocomplete="off"
                name="hidden"
                type="text"
                style="display:none;">
          <SingleOtpInput
            v-for="(item, i) in numInputs"
            :key="i"
            :focus="activeInput === i"
            :value="otp[i]"
            :separator="separator"
            :input-type="inputType"
            :is-last-child="i === numInputs - 1"
            :should-auto-focus="shouldAutoFocus"
            @on-change="handleOnChange"
            @on-keydown="handleOnKeyDown"
            @on-paste="handleOnPaste"
            @on-focus="handleOnFocus(i)"
            @on-blur="handleOnBlur"
          /></v-col>
            <v-col class="col-2">
              <v-btn id="clear-otp" @click="handleClearInput()" small depressed style="font-size:11px;margin-left:0px;margin-top:4px;background-color:white;" mr-2 >Clear Input</v-btn>
            </v-col>
          </v-row>
          
           
        </div>
   
</template>
<script>
import SingleOtpInput from "@/components/SingleOtpInput.vue";
export default {
    name:"VinputOtp",
    components:{
        SingleOtpInput
    },
      props: {
        numInputs: {
          default: 4,
        },
        separator: {
          type: String,
          default: '**',
        },
        inputClasses: {
          type: String,
        },
        inputType: {
          type: String,
          validator(value) {
            return ['number', 'tel', 'password'].includes(value);
          },
        },
        shouldAutoFocus: {
          type: Boolean,
          default: false,
        },
      },
      data() {
        return {
          activeInput: 0,
          otp: [],
          oldOtp: [],
          isMobile:false,
          val:4,
        };
      },
      mounted:async function() {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
      },
      methods: {
        onResize () {
            this.isMobile = window.innerWidth < 600
            if(this.isMobile){
               this.val = 8
            }else{
              this.val = 6
            }
          },
        handleOnFocus(index) {
          this.activeInput = index;
        },
        handleOnBlur() {
          this.activeInput = -1;
        },
        // Helper to return OTP from input
        checkFilledAllInputs() {
          if (this.otp.join('').length === this.numInputs) {
            return this.$emit('on-complete', this.otp.join(''));
          }
          return 'Wait until the user enters the required number of characters';
        },
        // Focus on input by index
        focusInput(input) {
          this.activeInput = Math.max(Math.min(this.numInputs - 1, input), 0);
        },
        // Focus on next input
        focusNextInput() {
          this.focusInput(this.activeInput + 1);
        },
        // Focus on previous input
        focusPrevInput() {
          this.focusInput(this.activeInput - 1);
        },
        // Change OTP value at focused input
        changeCodeAtFocus(value) {
          this.oldOtp = Object.assign([], this.otp);
          this.$set(this.otp, this.activeInput, value);
          if (this.oldOtp.join('') !== this.otp.join('')) {
            this.$emit('on-change', this.otp.join(''));
            this.checkFilledAllInputs();
          }
        },
        // Handle pasted OTP
        handleOnPaste(event) {
          event.preventDefault();
          const pastedData = event.clipboardData
            .getData('text/plain')
            .slice(0, this.numInputs - this.activeInput)
            .split('');
          if (this.inputType === 'number' && !pastedData.join('').match(/^\d+$/)) {
            return 'Invalid pasted data';
          }
          // Paste data from focused input onwards
          const currentCharsInOtp = this.otp.slice(0, this.activeInput);
          const combinedWithPastedData = currentCharsInOtp.concat(pastedData);
          this.$set(this, 'otp', combinedWithPastedData.slice(0, this.numInputs));
          this.focusInput(combinedWithPastedData.slice(0, this.numInputs).length);
          return this.checkFilledAllInputs();
        },
        handleOnChange(value) {
          this.changeCodeAtFocus(value);
          this.focusNextInput();
        },
        clearInput() {
          if (this.otp.length > 0) {
            this.$emit('on-change', '');
          }
          this.otp = [];
          this.activeInput = 0;
        },
        // Handle cases of backspace, delete, left arrow, right arrow
        handleOnKeyDown(event) {
          switch (event.keyCode) {
            case 8: // for BACKSPACE
              event.preventDefault();
              this.changeCodeAtFocus('');
              this.focusPrevInput();
              break;
            case 46:// for DELETE
              event.preventDefault();
              this.changeCodeAtFocus('');
              break;
            default:
              break;
          }
        },

      
          handleClearInput() {
            this.clearInput();
            this.otpcode = '';
          },
      }
 }
</script>


